<template>
    <div id="content">
        <!--
        <Menu page="images"></Menu>
        -->
        <transition appear name="appear">
            <div class="lds-spinner" v-if="!render">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </transition>
        <div v-if="render">
            <section v-if="$mq == 'desktop'">
                <div v-for="(image, idx) in store.orderedImages" class="imageElement" :style="{
                    width: getDivWidth(image),
                    flexGrow: getDivFlex(image)
                }">
                    <i :style="{ paddingBottom: getIPadding(image) }"></i>
                    <img loading="lazy" :src="image.thumbnail_small" :class="{
                        double: image.is_paired_with_next,
                        triple:
                            image.is_paired_with_next &&
                            getNextImage(image).is_paired_with_next,
                        websiteImage: image.is_website,
                        lightBorder: image.border == 'LI',
                        darkBorder: image.border == 'DA'
                    }" alt="" @click="handleClick(image)" />
                    <img loading="lazy" v-if="image.is_paired_with_next" :class="{
                        double: image.is_paired_with_next,
                        triple:
                            image.is_paired_with_next &&
                            getNextImage(image).is_paired_with_next,
                        lightBorder: getNextImage(image).border == 'LI',
                        darkBorder: getNextImage(image).border == 'DA',
                        websiteImage: getNextImage(image).is_website
                    }" :src="getNextImage(image).thumbnail_small" alt="" @click="handleClick(image)" />
                    <img loading="lazy" v-if="image.is_paired_with_next &&
                        getNextImage(image).is_paired_with_next
                        " :class="{
        triple: getNextImage(image).is_paired_with_next,
        lightBorder: getThirdImage(image).border == 'LI',
        darkBorder: getThirdImage(image).border == 'DA',
        websiteImage: getThirdImage(image).is_website
    }" :src="getThirdImage(image).thumbnail_small" alt="" @click="handleClick(image)" />
                    <p class="tabNum">{{ formatPosition(image.counter) }}</p>
                </div>
            </section>
            <section v-else id="mobileImages">
                <div v-for="(image, idx) in store.orderedImages" class="">
                    <img loading="lazy" :src="image.thumbnail_small" :class="{
                        double: image.is_paired_with_next,
                        triple:
                            image.is_paired_with_next &&
                            getNextImage(image).is_paired_with_next,
                        websiteImage: image.is_website,
                        lightBorder: image.border == 'LI',
                        darkBorder: image.border == 'DA'
                    }" alt="" @click="handleClick(image)" />
                    <img loading="lazy" v-if="image.is_paired_with_next" :class="{
                        double: image.is_paired_with_next,
                        triple:
                            image.is_paired_with_next &&
                            getNextImage(image).is_paired_with_next,
                        lightBorder: getNextImage(image).border == 'LI',
                        darkBorder: getNextImage(image).border == 'DA',
                        websiteImage: getNextImage(image).is_website
                    }" :src="getNextImage(image).thumbnail_small" alt="" @click="handleClick(image)" />
                    <img loading="lazy" v-if="image.is_paired_with_next &&
                        getNextImage(image).is_paired_with_next
                        " :class="{
        triple: getNextImage(image).is_paired_with_next,
        lightBorder: getThirdImage(image).border == 'LI',
        darkBorder: getThirdImage(image).border == 'DA',
        websiteImage: getThirdImage(image).is_website
    }" :src="getThirdImage(image).thumbnail_small" alt="" @click="handleClick(image)" />
                    <p class="tabNum">{{ formatPosition(image.counter) }}</p>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { store } from "@/centralStore";
import Menu from "@/components/Menu";
//import ImagesItem from '@/components/ImagesItem'
//import FldGrd from 'fld-grd'
export default {
    name: "Images",
    components: {
        //ImagesItem,
        Menu
    },
    data() {
        return {
            store: store.state,
            render: false,
            imageCounter: 0
            //projectIdx: 0,
            //imageCounter: 1,
        };
    },
    methods: {
        handleClick(image) {
            let myself = this;
            this.store.random = false;
            //this.store.imagesTransition = 'slideDown';
            //this.store.detailTransition = 'slideUp';
            //setTimeout(function(){
            //myself.$router.push({ name: 'detail-image', params: { slug: image.project_slug, id: image.id } })
            //}, 100)
            myself.$router.push({
                name: "detail-image",
                params: { slug: image.project_slug, id: image.id }
            });
        },
        //getPosition(image){
        //if (this.projectIdx != image.project){
        //this.imageCounter = 1
        //this.projectIdx = image.project;
        //} else {
        //this.imageCounter += 1
        //}
        //console.log(this.projectIdx)
        //return this.imageCounter.toString().padStart(3, '0');
        //return '1'

        //},
        formatPosition(position) {
            return position.toString().padStart(3, "0");
        },
        getDivWidth(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                //return image.width*360/image.height + window.innerWidth*0.005 + 'px'
                return (
                    (image.width * 370) / image.height +
                    window.innerWidth * 0.005 +
                    "px"
                );
            } else if (image.is_paired_with_next) {
                return (
                    (image.width * 240) / image.height +
                    window.innerWidth * 0.005 +
                    "px"
                );
            } else {
                return (image.width * 120) / image.height + "px";
            }
        },
        getDivFlex(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                return (image.width * 360) / image.height;
            } else if (image.is_paired_with_next) {
                return (image.width * 240) / image.height;
            } else {
                return (image.width * 120) / image.height;
            }
        },
        getIPadding(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                return (image.height / image.width) * 32 + "%";
            } else if (image.is_paired_with_next) {
                return (image.height / image.width) * 48.5 + "%";
            } else {
                return (image.height / image.width) * 101 + "%";
            }
        },
        getNextImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 1];
        },
        getThirdImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 2];
        },
        displayImages() {
            let startTime = new Date();
            let myself = this;
            this.store.orderedImages.forEach(image => {
                let img = new Image();
                img.src = image.thumbnail_small;
                img.onload = () => {
                    image.width = img.width;
                    image.height = img.height;
                    myself.imageCounter += 1;
                    //console.log(myself.store.totalImages)
                    //console.log(myself.imageCounter)
                    if (myself.imageCounter == myself.store.totalImages) {
                        //if (myself.imageCounter == 3){
                        myself.render = true;
                    }
                };
            });

            let endTime = new Date();
            let timeElapsed = endTime - startTime;
            console.log('displayImages', timeElapsed)

        }
    },
    activated() {
        this.store.lastIndex = "images";
        //this.store.inverted = false;
        let myself = this;
        //setTimeout(function(){
        //myself.store.currentImage = null;
        //}, 1000)
        this.store.imagesTransition = "";
    },

    mounted() {
        //let fldGrd = new FldGrd(document.querySelector('#fld-grd'), {
        //rowHeight: 200,
        //objSelector: 'img',
        //dataWidth: 'data-fld-width',
        //dataHeight: 'data-fld-height',
        //})
        //fldGrd.update();
        this.store.inverted = false;
        this.displayImages();
    },
    watch: {
        "store.imagesReady": function (val) {
            this.displayImages();
        }
    }
};
</script>

<style scoped>
#content {
    /*position: absolute;*/
    top: 0;
    width: 100vw;
    height: 100%;
    height: -webkit-fill-available;
    /*overflow: auto;*/
    background-color: black;
}

p {
    text-align: center;
    margin: 0.1rem 0 0rem;
}

@media screen and (min-width: 768px) {
    p {
        margin: 0.25rem 0 0.08rem;
    }
}

section {
    display: flex;
    flex-wrap: wrap;
    margin: 0rem 1rem 0.75rem;
    position: relative;
    top: 10.8rem;
    width: calc(100vw - 2rem);
}

@media screen and (min-width: 768px) {
    section {
        top: 3.55rem;
        margin: 0.5rem 0.75rem 0.5rem;
        width: calc(100vw - 1.5rem);
        /*margin: 0.2rem 0.75rem 0.75rem;*/
    }
}

section::after {
    content: "";
    flex-grow: 999999999;
}

div.imageElement {
    position: relative;
    margin: 0.25rem 0.25rem 0;
    color: #969696;
}

div.imageElement:hover {
    color: white;
}

i {
    display: block;
}

img {
    position: absolute;
    top: 0;
    width: 100%;
    vertical-align: bottom;
    object-fit: cover;
    cursor: pointer;
}

img.websiteImage {
    /*box-shadow: 0px 0px 0.3rem 0px #d2d2d2;*/
    border-radius: 0.25rem;
}

img.double {
    width: calc(50% - 0.25rem);
}

img.double:nth-child(3) {
    left: calc(50% + 0.25rem);
}

img.triple {
    width: calc(33% - 0.25rem);
}

img.triple:nth-child(3) {
    left: calc(33% + 0.25rem);
}

img.triple:nth-child(4) {
    left: calc(66% + 0.5rem);
}

.slideDown-leave-active,
.slideDown-enter-active {
    transition: 0.7s;
}

.slideDown-enter {
    transform: translateY(100vh);
}

.slideDown-enter-to {}

.slideDown-leave {}

.slideDown-leave-to {
    transform: translateY(100vh);
}

#mobileImages {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
}

#mobileImages img {
    position: static;
    max-width: 100%;
    /*max-height: calc(100% - 2.5rem);*/
    max-height: calc(28vw - 2.6rem);
    width: auto;
    /*object-fit: contain;*/
}

#mobileImages img.double {
    width: calc(50% - 0.26rem);
    margin-left: 0.5rem;
    object-position: left;
}

#mobileImages img.double:first-child {
    margin-left: 0;
    object-position: right;
}

#mobileImages img.triple {
    width: calc(32% - 0.26rem);
    margin-left: 0.5rem;
    object-position: center;
}

#mobileImages>div {
    height: calc(33vw - 1rem);
    text-align: center;
    position: relative;
}

#mobileImages>div>p {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.hasBorder {
    border: 0.03125rem solid #6b6b6b;
}

.lightBorder {
    border: 0.5px solid #565656;
    box-sizing: border-box;
}

.darkBorder {
    border: 0.5px solid #202020;
    box-sizing: border-box;
}

@media screen and (min-width: 768px) {
    .lightBorder {
        border: 1px solid #565656;
        box-sizing: border-box;
    }

    .darkBorder {
        border: 1px solid #202020;
        box-sizing: border-box;
    }
}

.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>
